import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { PlusIcon } from '../icons';
import { HOME_FAQS } from '../../data/homepageData';
import { withEmailLinks } from '../../utils/emailLinks';

// One row of the FAQ accordion. Independent open/close state per row.
function FaqItem({ question, answer, links }) {
  const [active, setActive] = useState(false);
  return (
    <div className={`asg-faq-item${active ? ' active' : ''}`}>
      <button className="asg-faq-q" onClick={() => setActive(!active)}>
        <h3>{question}</h3>
        <PlusIcon />
      </button>
      <div className="asg-faq-a">
        <div className="asg-faq-a-inner">
          <p>{withEmailLinks(answer, 'asg-faq-link')}</p>
          {links && links.length > 0 && (
            <p className="asg-faq-links">
              {links.map((l, i) => (
                <React.Fragment key={l.to}>
                  {i > 0 && <span className="asg-faq-sep"> · </span>}
                  <Link to={l.to} className="asg-faq-link">{l.label}</Link>
                </React.Fragment>
              ))}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

// FAQ accordion section near the bottom of HomePage. Reads from
// HOME_FAQS (data/homepageData.js) — admin edits the FAQ list by
// editing that data file.
export default function FaqSection() {
  return (
    <section className="asg-faq" id="faq">
      <div className="asg-faq-inner">
        <div className="asg-faq-header asg-reveal">
          <p className="asg-section-label">Common Questions</p>
          <h2 className="asg-section-title">Everything you need to know.</h2>
        </div>
        <div className="asg-reveal">
          {HOME_FAQS.map((faq, i) => (
            <FaqItem key={i} question={faq.question} answer={faq.answer} links={faq.links} />
          ))}
        </div>
      </div>
    </section>
  );
}
